const POPULAR_KEYWORDS_LINKS = {
    FORTNITE_LOGOS: {
        copiesKey: 'fortnite_logos',
        bigQuery: 'fortnite',
        mixpanel: 'Fortnite',
        tag: 'fortnite'
    },
    CLAN_LOGOS: {
        copiesKey: 'clan_logos',
        bigQuery: 'clan',
        mixpanel: 'Clan',
        tag: 'clan'
    },
    TWITCH_LOGOS: {
        copiesKey: 'twitch_logos',
        bigQuery: 'twitch',
        mixpanel: 'Twitch',
        tag: 'twitch'
    },
    FACE_LOGOS: {
        copiesKey: 'face_logos',
        bigQuery: 'face',
        mixpanel: 'Face',
        tag: 'face'
    },
    CIRCLE_LOGOS: {
        copiesKey: 'circle_logos',
        bigQuery: 'circle',
        mixpanel: 'Circle',
        tag: 'circle'
    },
    CHIRCH_LOGOS: {
        copiesKey: 'church_logos',
        bigQuery: 'church',
        mixpanel: 'Church',
        tag: 'church'
    },
    PODCAST_LOGOS: {
        copiesKey: 'podcast_logos',
        bigQuery: 'podcast',
        mixpanel: 'Podcast',
        tag: 'podcast'
    },
    YOUTUBE_LOGOS: {
        copiesKey: 'youtube_logos',
        bigQuery: 'youtube',
        mixpanel: 'Youtube',
        tag: 'youtube'
    },
    CLOTHING_LOGOS: {
        copiesKey: 'clothing_logos',
        bigQuery: 'clothing',
        mixpanel: 'Clothing',
        tag: 'clothing'
    },
    HAIR_LOGOS: {
        copiesKey: 'hair_logos',
        bigQuery: 'hair',
        mixpanel: 'Hair',
        tag: 'hair'
    },
    JAPANESE_LOGOS: {
        copiesKey: 'japanese_logos',
        bigQuery: 'japanese',
        mixpanel: 'Japanese',
        tag: 'japanese'
    },
    BAKERY_LOGOS: {
        copiesKey: 'bakery_logos',
        bigQuery: 'bakery',
        mixpanel: 'Bakery',
        tag: 'bakery'
    },
    BARBER_LOGOS: {
        copiesKey: 'barber_logos',
        bigQuery: 'barber',
        mixpanel: 'Barber',
        tag: 'barber'
    },
    PUBG_LOGOS: {
        copiesKey: 'pubg_logos',
        bigQuery: 'pubg',
        mixpanel: 'Pubg',
        tag: 'pubg'
    },
    HANDYMAN_LOGOS: {
        copiesKey: 'handyman_logos',
        bigQuery: 'handyman',
        mixpanel: 'Handyman',
        tag: 'handyman'
    },
    FITNESS_LOGOS: {
        copiesKey: 'fitness_logos',
        bigQuery: 'fitness',
        mixpanel: 'Fitness',
        tag: 'fitness'
    },
    FLORAL_LOGOS: {
        copiesKey: 'floral_logos',
        bigQuery: 'floral',
        mixpanel: 'Floral',
        tag: 'floral'
    },
    GYM_LOGOS: {
        copiesKey: 'gym_logos',
        bigQuery: 'gym',
        mixpanel: 'Gym',
        tag: 'gym'
    },
    LANDSCAPE_LOGOS: {
        copiesKey: 'landscape_logos',
        bigQuery: 'landscape',
        mixpanel: 'Landscape',
        tag: 'landscape'
    },
    MEDICAL_LOGOS: {
        copiesKey: 'medical_logos',
        bigQuery: 'medical',
        mixpanel: 'Medical',
        tag: 'medical'
    },
    SPORTS_LOGOS: {
        copiesKey: 'sports_logos',
        bigQuery: 'sports',
        mixpanel: 'Sports',
        tag: 'sports'
    }
};

const TOP_INDUSTRIES_LINKS = {
    GAMING_LOGOS: {
        copiesKey: 'gaming_logos',
        bigQuery: 'gaming',
        mixpanel: 'Gaming',
        tag: 'gaming'
    },
    ESPORTS_LOGOS: {
        copiesKey: 'esports_logos',
        bigQuery: 'esports',
        mixpanel: 'Exports',
        tag: 'esports-fan-club'
    },
    BANDS_LOGOS: {
        copiesKey: 'bands_logos',
        bigQuery: 'bands',
        mixpanel: 'Bands',
        tag: 'bands'
    },
    PHOTOGRAPHY_LOGOS: {
        copiesKey: 'photography_logos',
        bigQuery: 'photography',
        mixpanel: 'Photography',
        tag: 'photography'
    },
    DJ_LOGOS: {
        copiesKey: 'dj_logos',
        bigQuery: 'dj',
        mixpanel: 'Dj',
        tag: 'dj'
    },
    BEAUTY_LOGOS: {
        copiesKey: 'beauty_logos',
        bigQuery: 'beauty',
        mixpanel: 'Beauty',
        tag: 'beauty-and-cosmetics'
    },
    MUSIC_LOGOS: {
        copiesKey: 'music_logos',
        bigQuery: 'music',
        mixpanel: 'Music',
        tag: 'music'
    },
    RESTAURANT_LOGOS: {
        copiesKey: 'restaurant_logos',
        bigQuery: 'restaurant',
        mixpanel: 'Restaurant',
        tag: 'restaurants'
    },
    REAL_ESTATE_LOGOS: {
        copiesKey: 'real_estate_logos',
        bigQuery: 'real_estate',
        mixpanel: 'Real Estate',
        tag: 'real-estate'
    },
    MAKEUP_LOGOS: {
        copiesKey: 'makeup_logos',
        bigQuery: 'makeup',
        mixpanel: 'Makeup',
        tag: 'makeup'
    },
    CONSTRUCTION_LOGOS: {
        copiesKey: 'construction_logos',
        bigQuery: 'construction',
        mixpanel: 'Construction',
        tag: 'construction'
    },
    ANIMAL_AND_PET_LOGOS: {
        copiesKey: 'animal_and_pet_logos',
        bigQuery: 'animal_and_pet',
        mixpanel: 'Animal & Pet',
        tag: 'animals-and-pets'
    },
    AUTOMOTIVE_LOGOS: {
        copiesKey: 'automotive_logos',
        bigQuery: 'automotive',
        mixpanel: 'Automotive',
        tag: 'transportation-or-automotive'
    },
    FOOD_LOGOS: {
        copiesKey: 'food_logos',
        bigQuery: 'food',
        mixpanel: 'Food',
        tag: 'food-and-beverage'
    },
    SALOON_LOGOS: {
        copiesKey: 'salon_logos',
        bigQuery: 'salon',
        mixpanel: 'Salon',
        tag: 'beauty-salon'
    },
    FASHION_LOGOS: {
        copiesKey: 'fashion_logos',
        bigQuery: 'fashion',
        mixpanel: 'Fashion',
        tag: 'fashion-and-apparel'
    },
    ART_LOGOS: {
        copiesKey: 'art_logos',
        bigQuery: 'art',
        mixpanel: 'Art',
        tag: 'art-and-design'
    },
    LAW_LOGOS: {
        copiesKey: 'law_logos',
        bigQuery: 'law',
        mixpanel: 'Law',
        tag: 'law'
    },
    BAR_LOGOS: {
        copiesKey: 'bar_logos',
        bigQuery: 'bar',
        mixpanel: 'Bar',
        tag: 'bars'
    }
};

const DOMAIN_SOURCES = {
    LOGO_MAKER: 'logo_maker'
};

const PACKAGES_HREFS = {
    BASIC: 'https://fiverr-makers.s3.amazonaws.com/Fiverr_Basic_Kit.zip',
    PREMIUM: 'https://fiverr-makers.s3.amazonaws.com/Fiverr_Advanced_Kit.zip'
};

const BASIC_FEATURES = [
    'full_commercial_rights',
    'high_resolution_png_files',
    'transparent_background'
];

const PREMIUM_FEATURES = [
    'full_commercial_rights',
    'high_resolution_png_files',
    'transparent_background',
    'print_ready',
    'resizable_vector_files',
    'websites_and_app',
    'social_media_kit',
    'brand_guidelines',
    'zoom_backgrounds'
];

const BASIC_PACKAGE = {
    'id': 1,
    'type': 'basic',
    'price': 3000,
    'downloadLink': PACKAGES_HREFS.BASIC,
    'isHighlighted': false
};
const PREMIUM_PACKAGE = {
    'id': 2,
    'type': 'premium',
    'price': 6000,
    'downloadLink': PACKAGES_HREFS.PREMIUM,
    'isHighlighted': true
};

const PACKAGE_TYPES = {
    BASIC: 'basic',
    PREMIUM: 'premium'
};

const UPGRADE_PACKAGE_TYPES = {
    recurring_basic: 'recurring_basic',
    premium_upgrade: 'premium_upgrade',
    discounted_premium: 'discounted_premium',
    recurring_premium: 'recurring_premium',
    upgrade: 'upgrade',
    discounted_upgrade: 'discounted_upgrade',
    system_upgrade: 'system_upgrade'
};

const PRO_UPGRADE_PACKAGES = [
    UPGRADE_PACKAGE_TYPES.recurring_premium,
    UPGRADE_PACKAGE_TYPES.discounted_premium,
    UPGRADE_PACKAGE_TYPES.premium_upgrade
];

const PACKAGE_TYPES_MAP = {
    basic: PACKAGE_TYPES.BASIC,
    premium: PACKAGE_TYPES.PREMIUM,
    [UPGRADE_PACKAGE_TYPES.recurring_basic]: PACKAGE_TYPES.BASIC,
    [UPGRADE_PACKAGE_TYPES.premium_upgrade]: PACKAGE_TYPES.PREMIUM,
    [UPGRADE_PACKAGE_TYPES.discounted_premium]: PACKAGE_TYPES.PREMIUM,
    [UPGRADE_PACKAGE_TYPES.recurring_premium]: PACKAGE_TYPES.PREMIUM,
    [UPGRADE_PACKAGE_TYPES.upgrade]: PACKAGE_TYPES.PREMIUM,
    [UPGRADE_PACKAGE_TYPES.discounted_upgrade]: PACKAGE_TYPES.PREMIUM,
    [UPGRADE_PACKAGE_TYPES.system_upgrade]: PACKAGE_TYPES.PREMIUM
};

const PACKAGES = [
    {
        ...BASIC_PACKAGE,
        'features': BASIC_FEATURES
    },
    {
        ...PREMIUM_PACKAGE,
        'features': PREMIUM_FEATURES
    },
    {
        ...BASIC_PACKAGE,
        'features': BASIC_FEATURES,
        type: UPGRADE_PACKAGE_TYPES.recurring_basic
    },
    {
        ...PREMIUM_PACKAGE,
        'features': PREMIUM_FEATURES,
        type: UPGRADE_PACKAGE_TYPES.discounted_premium
    },
    {
        ...PREMIUM_PACKAGE,
        'features': PREMIUM_FEATURES,
        type: UPGRADE_PACKAGE_TYPES.recurring_premium
    },
    {
        ...PREMIUM_PACKAGE,
        'features': PREMIUM_FEATURES,
        type: UPGRADE_PACKAGE_TYPES.premium_upgrade
    },
    {
        ...PREMIUM_PACKAGE,
        'features': PREMIUM_FEATURES,
        type: UPGRADE_PACKAGE_TYPES.discounted_upgrade
    }
];

/**
 * Variation card modes, Will be used to render card according to svg / preview mode.
 * @type {{PREVIEW: string, SVG: string}}
 */
const VARIATIONS_DISPLAY_MODES = {
    PREVIEW: 'preview',
    SVG: 'svg'
};

const LISTING_SOURCE = {
    MARKETPLACE: 'marketplace',
    MP_FORK: 'mp_fork'
};

module.exports = {
    POPULAR_KEYWORDS_LINKS,
    TOP_INDUSTRIES_LINKS,
    DOMAIN_SOURCES,
    PACKAGES_HREFS,
    BASIC_FEATURES,
    PREMIUM_FEATURES,
    BASIC_PACKAGE,
    PREMIUM_PACKAGE,
    PACKAGE_TYPES,
    UPGRADE_PACKAGE_TYPES,
    PRO_UPGRADE_PACKAGES,
    PACKAGE_TYPES_MAP,
    PACKAGES,
    VARIATIONS_DISPLAY_MODES,
    LISTING_SOURCE
};
